var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 42,
    width: 42,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "none",
    d: "m0,0l48,0l0,48l-48,0l0,-48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#FDBF82",
    d: "m20,0c-11.04,0 -20,8.95 -20,20s8.96,20 20,20s20,-8.95 20,-20s-8.96,-20 -20,-20zm2,30l-4,0l0,-4l4,0l0,4zm0,-8l-4,0l0,-12l4,0l0,12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.a2fe091f90de37ea4ab0237e806c5f07.svg";
export { ForwardRef as ReactComponent };